const en = {
  UserList: {
    empty: 'No users found',
  },

  FundTransactionListItem: {
    refunded: 'Refunded',
    notRefunded: 'Refund',
    AdminTransaction: 'Admin Transaction',
  },

  UserChargingTokenList: {
    empty: 'No tokens found',
    AppToken: 'App Token',
    Active: 'Active',
    type: 'Type',
    id: 'Token Huid',
    contractId: 'Contract ID',
    deactivateButton: 'Action',
    updatedAt: 'Linked On',
  },
  PaymentCardList: {
    title: 'Payment Cards',
    type: 'Type',
    cardNumber: 'Card Number',
    uid: 'Card Uid',
    createdAt: 'Linked On',
    country: 'Country',
    deleteButtonAction: 'Action',
    deleteButton: 'Delete',
    DeleteTitleModal: 'Delete Payment Card?',
    DeleteBodyText: 'This cannot be reversed.',
  },
  UserListHeader: {
    sort: 'Recent',
    users: 'Users',
  },
  ChargingTransactionListItem: {
    duration: 'Charging duration: ',
    uid: 'Charger uid: ',
    confirmRefund: 'This cannot be reversed.',
    confirmRefundTitle: 'Refund transaction?',
    refundButton: 'Refund',
  },
  IFRangePicker: {
    Min: 'Min',
    Max: 'Max',
    Ok: 'OK',
  },
  IFFilter: {
    saveButton: 'Apply',
    clearButton: 'Clear',
    activeOption: 'Active',
    inactiveOption: 'Inactive',
    dateRangeButton: 'Date',
    filterBy: 'Filter by',
    statusSelect: 'Status',
    or: ' or ',
    selectRange: 'Select Date Range',
    Ascending: 'Ascending',
    Descending: 'Descending',
    Download: 'Download',
  },

  AdminList: {
    empty: 'No admins found',
    deleteModalCancel: 'Cancel',
    deleteModalConfirm: 'Delete',
    deleteModalTitle: 'Confirm Delete',
    deleteModalText: 'Are you sure you want to delete this Administrator?',
    Name: 'Name',
    Email: 'Email',
    CreatedOn: 'Created On',
    Role: 'Role',
    Save: 'Save',
    Edit: 'Edit',
    Country: 'Country',
    AdminDeleted: 'Admin Deleted successfully',
  },
  InvitationsList: {
    InvitationSent: 'Invitation Sent',
    deleteInviteAdminModalText: 'Are you sure you want to delete this invite?',
    ResendInviteAdminEmail: 'Resend',
    deleteModalConfirm: 'Delete',
    Country: 'Country',
    InvitationDeleted: 'Invitation Deleted successfully',
  },

  RoleList: {
    Name: 'Name',
    Admins: 'Admins',
    Permissions: 'Permissions',
    UpdatedOn: 'Updated On',
    MoreInfo: 'More Info',
    EmptyAdmins: '--',
    deleteModalCancel: 'Cancel',
    deleteModalConfirm: 'Delete',
    deleteModalTitle: 'Confirm Delete',
    deleteModalText: 'Are you sure you want to delete this Role?',
    Country: 'Country',
    RoleSuccessCreated: 'Role Created Successfully',
    RoleDeletedSuccessfully: 'Role Deleted Successfully',
  },
  RoleDetails: {
    Admins: 'Admins',
    NoAdmins: 'No Admins Assigned.',
    Permissions: 'Permissions',
    Name: 'Name',
    CreatedAt: 'Created At',
    UpdatedAt: 'Updated At',
    Save: 'Save',
    Cancel: 'Cancel',
    Edit: 'Edit',
    Delete: 'Delete',
    RoleDetails: 'Role Details',
    RoleNameForm: 'Role Name',
    Country: 'Country',
    Submit: 'Submit',
    NoAdminsAssigned: 'No Admins Assigned to this Role',
  },

  DialogModal: {
    defaultCancelButtonText: 'Cancel',
  },

  LoginPage: {
    WelcomeTitle: 'Welcome Back!',
    WelcomeText: 'Sign in to your account',
    ForgotPassword: 'Forgot Password?',
    Login: 'Login',
    Required: 'Required*',
    ShortPassword: 'Password must be at least 12 characters',
    Setup2faTitle: 'Set up Two-Factor Authentication',
    Setup2faSubtitle:
      'Infinity EV requires you to set up two-factor authentication',
    DownloadAppTitle: 'Download an Authenticator App',
    DownloadAppSubtitle:
      'Install an authenticator app like Google Authenticator, Microsoft Authenticator, or 1Password.',
    ScanTitle: 'Scan this Barcode',
    ScanSubtitle: 'Use your authenticator app to scan this QR code.',
    ManualKey: 'Or, enter the following code manually instead.',
    Pin: 'Enter the 6-digit code from your authenticator',
    TwoFactorSetupComplete: 'Two-factor setup complete, please login',
  },
  ResetPassword: {
    Title: 'Reset Password',
    Email: 'Email',
    Name: 'Name',
    Password: 'Password',
    ConfirmPassword: 'Confirm Password',
    Required: 'Required*',
    ShortPassword: 'Password must be at least 12 characters',
    PasswordsMustMatch: 'Passwords do not match',
    Reset: 'Reset',
    ModalTitle: 'Confirm Password Reset',
    ModalSubTitle: 'Please enter the verification code sent to',
    PinValidationString: '0123456789',
    ModalButtonText: 'Confirm',
    ResetPasswordSuccess: 'Password was reset successfully',
    Required: 'Required*',
    CodeNotSentText: 'Did not get your code? ',
    ResendText: 'Resend code',
    ResendWithTimer: 'Resend in',
    PasswordLowercase: 'Password must contain at least one lowercase letter.',
    PasswordUppercase: 'Password must contain at least one uppercase letter.',
    PasswordNumber: 'Password must contain at least one number.',
    PasswordSymbol: 'Password must contain at least one symbol.',
  },
  CreateAdminAccountPage: {
    CreateAccount: 'Create Account to continue.',
    Register: 'Register',
    Required: 'Required*',
    WelcomeTitle: 'Welcome!',
    ShortPassword: 'Password must be at least 12 characters',
    PasswordsMustMatch: 'Passwords do not match',
    Name: 'Name',
    Password: 'Password',
    ConfirmPassword: 'Confirm Password',
    Email: 'Email',
    AcceptedInvite: 'You have already accepted an invitation.',
    ToLogin: 'To login, please click ',
    Here: 'here.',
    InvitationSent: 'Invitation sent successfully',
    AccountCreated: 'Account created successfully',
    PasswordLowercase: 'Password must contain at least one lowercase letter.',
    PasswordUppercase: 'Password must contain at least one uppercase letter.',
    PasswordNumber: 'Password must contain at least one number.',
    PasswordSymbol: 'Password must contain at least one symbol.',
    MinLength: 'Password must be at least 12 characters',
  },

  AdminPage: {
    AdminFilterPlaceholder: 'Filter admins by...',
    InviteAdminButton: 'Invite',
    NewRole: 'New Role',
    CreateNewRole: 'Create New Role',
    InviteAdmin: 'Invite Admin',
    InviteAdminEmail: 'Email',
    InviteAdminRole: 'Role',
    InviteAdminCountry: 'Country',
    FieldRequired: 'Required*',
    InvalidEmail: 'Invalid Email',
    MinThreeCharacters: 'Name must be at least 3 characters',
    InviteAdminCountryRequired: 'Country is required first',
  },

  UserPage: {
    LastUpdated: 'Last Updated',
    Email: 'Email',
    Phone: 'Phone',
    Country: 'Country',
    JoinedOn: 'Joined On',
    Wallet: 'Billing Account',
    ChargingTokensTitle: 'Charging Tokens',
    ChargingTokensButton: 'Link',
    TransactionsTitle: 'Transactions',
    TransactionNoRecord: 'No records to display',
    EmptyUsers: 'No records to display',
    filterNoUsers: 'Filter does not match any logs, try a new search',
    query: 'query',
    TransactionTableColumns: {
      type: 'Type',
      Type: {
        charge: 'Charge',
        addMoney: 'Add Money',
        refund: 'Refund',
      },
      transactionID: 'Transaction ID',
      Name: 'Reference',
      Status: 'Status',
      Amount: 'Amount',
      Balance: 'Balance (before → after)',
      BalanceNotRecorded: 'Not recorded',
      ProcessedOn: 'Processed on',
    },
    paymentTableColumns: {
      paymentID: 'Payment ID',
      Status: 'Status',
      Amount: 'Amount',
      PaymentIssuer: 'Payment Issuer',
      ProcessedOn: 'Processed on',
    },
    ongoingSessionsTableColumns: {
      title: 'Ongoing Sessions',
      StationName: 'Station Name',
      tokenID: 'Token uid',
      energyConsumed: 'Energy Consumption',
      duration: 'Duration',
      country: 'Country',
      status: 'Status',
    },
    ActionsTitle: 'Actions',
    AdjustTitle: 'Adjust Billing Account',
    AddCardTitle: 'Link cards',
    AddCardText:
      'Please enter the contract id(s), separated by commas or line breaks.',
    AddCardErrorMessage: 'There is a an issue with the following cards:',
    EditButton: 'Edit',
    DeactivateButton: 'Deactivate',
    ActivateButton: 'Activate',
    AddButton: 'Add',
    SubtractButton: 'Subtract',
    Amount: 'Amount',
    Currency: 'EGP',
    Points: 'PTS',
    DeactivateTitle: 'Deactivate User?',
    ActivateTitle: 'Activate User?',
    DeactivateTitleToken: 'Deactivate Token?',
    DeactivateBodyText: 'This user will no longer be able to use the App.',
    ActivateBodyText: 'Are you sure you want to activate this user?',
    DeactivateConfirm: 'Deactivate',
    ActivateConfirm: 'Activate',
    AddCardTextFieldLabel: 'Contract IDs',
    AddCardButtonText: 'Add',
    AddCardSuccessMessage: 'Card(s) linked Successfully',
    ChangePhoneSuccessMessage: 'Phone Number Changed Successfully',
    AdjustAmountButtonTextAdd: 'Add',
    AdjustAmountButtonTextSubtract: 'Subtract',
    UsersFilterPlaceholder: 'Filter users by',
    TransactionsFilterPlaceholder: 'Filter transactions by',
    PaymentsFilterPlaceholder: 'Filter payment sessions by',
    ViewTable: 'Table',
    ViewBalanceTimeline: 'Balance Timeline',
    EditPhoneNumberModalTitle: 'Edit Phone Number',
    EditPhoneNumberModalAcceptText: 'Done',
    EditPhoneNumberTextFieldTitle: 'Phone',
    DeactivateTokenText: 'This cannot be reversed.',
    Deactivated: 'Deactivated',
    PointsInfoModalTitle: 'Points',
    NoSessions: 'There are no sessions',
    WalletTitle: 'Wallet',
    WalletSuccessMessage: 'Billing Account Adjusted Successfully',
    //Adjust Wallet Items
    AmountTitle: 'Current Amount',
    ActionTitle: 'Action',
    Amount: 'Amount',
    AdjustedAmount: 'Adjusted Amount',
    Adjust: 'Adjust',
    EmailVerified: 'Verified',
    EmailNotVerified: 'Not Verified',
    EditEmailModalTitle: 'Edit Email',
    EditEmailModalAcceptText: 'Done',
    EmailFieldTitle: 'Email',
    EmailVerifiedToggleTitle: 'Email Verified',
    EmailVerifiedToggleSubtitle: 'Override verification status',
    ResendVerificationLink: 'Resend verification link',
    ChangeEmailSuccessMessage: 'Email Changed Successfully',
    ResendEmailVerificationSuccessMessage: 'Verification Link Sent Successfully',
    NotificationsFilterPlaceholder: 'Filter notifications by',
    NotificationTableColumns: {
      Type: 'Type',
      Title: 'Title',
      Status: 'Status',
      SentOn: 'Sent on',
      Read: 'Read',
      Unread: 'Unread',
    },
    Timeline: {
      View: 'View timeline',
      Title: 'Session timeline',
      Total: 'Total',
      Charging: 'Charging',
      Grace: 'Grace',
      Idle: 'Idle',
      NotificationsSent: 'Notifications sent',
      NoNotifications: 'No notifications were sent during this session',
      NotTracked: "Notifications aren't available for this session.",
      SessionStart: 'Session start',
      SessionEnd: 'Session end',
    },
    NotificationDetails: {
      Title: 'Notification Details',
      TitleEn: 'Title (EN)',
      TitleAr: 'Title (AR)',
      MessageEn: 'Message (EN)',
      MessageAr: 'Message (AR)',
      Type: 'Type',
      Status: 'Status',
      RedirectUrl: 'Redirect URL',
      NotificationId: 'Notification ID',
      CreatedAt: 'Created at',
    },
  },
  BalanceTimeline: {
    BalanceNow: 'Balance after latest transaction',
    NoMovement: 'No balance movement',
    NotRecorded: 'Not recorded',
    BalanceNotRecorded: 'Balance not recorded for this transaction',
    NoTransactions: 'No transactions to build a balance trail from',
    Invoiced: 'Invoiced',
    InvoicedTooltip:
      'This charge was settled on an invoice, so it never moved the wallet balance.',
    Inconsistent: 'Amount mismatch',
    InconsistentTooltip:
      'The recorded balance movement does not match this transaction\u2019s amount of {{amount}}.',
    UnexplainedGap:
      'Balance moved by {{amount}} here with no transaction to account for it.',
  },
  TransactionDetails: {
    CharginSessionTitle: 'Charging Session Details',
    Name: 'Station Name',
    Start: 'Start',
    End: 'End',
    Duration: 'Duration',
    Consumption: 'Consumption',
    Tariff: 'Tariff',
    PointsTariff: 'Points Tariff',
    ChargerType: 'Charger Type',
    EvseID: 'Evse ID',
    TransactionDetailsTitle: 'Transaction Details',
    TokenType: 'Token Type',
    TokenID: 'Token ID',
    TransactionType: 'Transaction Type',
    Amount: 'Amount',
    PointsAmount: 'Points Amount',
    ConnectorUid: 'Connector Uid',
    Remark: 'Remark',
    BalanceBefore: 'Balance Before',
    BalanceAfter: 'Balance After',
    BalanceNotRecorded: 'Not recorded',
  },
  CostBreakdown: {
    Title: 'Cost Breakdown',
    Type: 'Type',
    Volume: 'Volume',
    ExclVat: 'Excl. VAT',
    InclVat: 'Incl. VAT',
    Subtotal: 'Subtotal',
    Vat: 'VAT',
    Total: 'Total',
    PointsTotal: 'Points Total',
    Points: 'PTS',
    TypeEnergy: 'Energy',
    TypeTime: 'Time',
    TypeParkingTime: 'Parking Time',
    TypeFlat: 'Flat',
  },
  FundTransactionDetails: {
    General: {
      title: 'Payment Details',
      amount: 'Amount',
      credit: 'is Credit',
      refunded: 'is Refunded',
      status: 'status',
      issuer: 'Payment Issuer',
      balanceBefore: 'Balance Before',
      balanceAfter: 'Balance After',
      balanceNotRecorded: 'Not recorded',
    },
    title: 'Payment Issuer Details',
    Qnb: {
      fees: 'Fees',
      orderId: 'Order ID',
      paymentId: 'Payment ID',
    },
    Internal: {
      adminId: 'Admin ID',
    },
  },
  PointsItem: {
    ExpiredText: 'Expired',
    ExpiresOnText: 'Expires on ',
    CreatedOnText: 'Created on ',
    pointsTableColumns: {
      Name: 'Name',
      Status: 'Status',
      Balance: 'Balance',
      CreatedOn: 'Created on',
    },
  },

  PointsList: {
    NoPointsText: 'No Points',
    NoSessions: 'There are no sessions',
    PaymentSessions: 'Payment Sessions',
  },

  PushNotificationsPanel: {
    PanelTitleSend: 'Send Push Notification',
    PanelTitleEdit: 'Edit Push Notification',
    PanelTitleGroupEdit: 'Edit Notification Group',
    PanelTitleGroupCreate: 'Create Notification Group',
    EnglishTitle: 'Title (en)',
    EnglishBody: 'Body (en)',
    ArabicTitle: 'Title (ar)',
    ArabicBody: 'Body (ar)',
    Group: 'Group',
    ScheduledAt: 'Scheduled At',
    StationId: 'Station ID / URl',
    DevicePreviewTitle: 'Device View',
    Required: 'Required*',
    MinTitle: 'Title must be at least 3 characters',
    MinBody: 'Body must be at least 3 characters',
    sendButton: 'Send',
    editButton: 'Submit',
    saveButton: 'Save',
    deleteButton: 'Delete',
    createButton: 'Create',
    invalidIdText: 'Please enter a valid ID',
    sendNow: 'Now',
    sendLater: 'Later',
    minName: 'Name must be at least 3 characters',
    scheduleButton: 'Schedule',
    scheduleSuccess: 'Notification Scheduled Successfully',
    submitButton: 'Submit',
    editButton: 'Edit',
    cancelButton: 'Cancel',
    cancelNotification: 'Cancel Notification',
    keepNotification: 'Keep',
    yesCancel: 'Yes, Cancel',
    SuccessMessage: 'Notification Sent Successfully',
    editSuccess: 'Notification Edited Successfully',
    editGroupSuccess: 'Group Edited Successfully',
    deleteGroupSuccess: 'Group Deleted Successfully',
    createGroupSuccess: 'Group Created Successfully',
    scheduleSuccess: 'Notification Scheduled Successfully',
    cancelSuccess: 'Notification Cancelled Successfully',
    NotiFilterPlaceholder: 'Filter Notifications by',
    GroupFilterPlaceholder: 'Filter Notification Groups by',
    NotificationsTableColumns: {
      Title: 'Notification Title',
      Id: 'Notification ID',
      Status: 'Notification Status',
      Groups: 'Notification Groups',
      ScheduledAt: 'Scheduled at',
    },
    confirmCancel: ' Confirm',
    cancelText: 'Are you sure you want to cancel this notification?',
    deleteGroupText: 'Are you sure you want to delete this notification group?',
    cancelSuccess: 'Notification Cancelled Successfully',

    dialogTitle: 'Confirm Cancel',
    groupDialogTitle: 'Delete Notification Group',
    confirmCancel: ' Confirm',
    GroupsTableColumns: {
      Name: 'Name',
      Count: 'Users Count',
      Country: 'Country',
      Query: 'Query',
    },
    notificationsTab: 'Notifications',
    groupsTab: 'Groups',
  },
  NotificationDetails: {
    Title: 'Notification Details',
    EnglishTitle: 'Title (en)',
    ArabicTitle: 'Title (ar)',
    EnglishMessage: 'Body (en)',
    ArabicBody: 'Body (ar)',
    Url: 'URL',
    Groups: 'Notification Groups',
    CreatedAt: 'Created At',
    ScheduledAt: 'Scheduled At',
  },

  TransactionsPage: {
    filterNoTransaction: 'Filter does not match any logs, try a new search',
    TransactionsFilterPlaceholder: 'Filter transactions by',
    TotalMoneyCollected: 'Total Money Collected',
    TotalChargingBalance: 'Total Charging Balance',
    TotalEnergyConsumption: 'Total Energy Consumption',
    TotalUsers: 'Number of Active Users',
    PhoneNumber: 'Phone Number',
    CustomerName: 'Name',
    TransactionId: 'Transaction ID',
    TransactionType: 'Transaction Type',
    Amount: 'Amount',
    EnergyConsumption: 'Energy Consumption',
    TransactionDate: 'Transaction Date',
    NoTransactions: 'No transactions found',
    NoTransactionsList: 'There are no transactions',
    ChartNoData: 'No Data Available',
    ChartYAxis: 'Energy Consumption (kWh)',
    UserBalancesModal: {
      ButtonLabel: 'User Balances',
      Title: 'Download User Balances',
      Description:
        'Download a CSV snapshot of every user balance as it stood at the end of the selected date.',
      SelectDate: 'Select a date',
      Download: 'Download CSV',
    },
    TransactionTableColumns: {
      UserId: 'User ID',
      TransactionId: 'Transaction ID',
      TransactionType: 'Type',
      Amount: 'Amount',
      EnergyConsumption: 'Energy',
      Balance: 'Balance (before → after)',
      BalanceNotRecorded: 'Not recorded',
      TransactionDate: 'Transaction Date',
      StationID: 'Station ID',
      ConnectorUid: 'Connector Uid',
    },
  },

  VouchersPage: {
    NoVouchers: 'No vouchers found',
    VouchersFilterPlaceholder: 'Filter vouchers by',
    VouchersTitle: 'Vouchers',
    VouchersName: 'Name',
    VouchersCode: 'Code',
    VouchersPoints: 'Points',
    VouchersRedeemed: 'Redeemed',
    VouchersValidity: 'Validity (days)',
    VouchersExpiry: 'Expiry',
    Country: 'Country',
    ExpiredText: 'Expired',
    ExpiresOnText: 'Expires on ',
    Add: 'Add',
    AddNewVoucher: 'Add Voucher',
    Required: 'Required*',
    Submit: 'Submit',
    VoucherNameForm: 'Voucher name',
    VoucherCodeForm: 'Voucher code',
    VoucherPointsForm: 'Number of points',
    VoucherMaxRedeemCountPerUser: 'Number of redeems per user',
    RedeemPerUser: 'Redeem Per User',
    VoucherMaxRedeemedForm: 'Number of redeems',
    ValidityForm: 'Validity (days)',
    ExpiryForm: 'Expiry date',
    Done: 'Done',
    Cancel: 'Cancel',
    NoExpiryDate: 'No Expiry Date',
    AddVoucherSuccessMessage: 'Voucher added Successfully',
    deleteVoucherSuccessMessage: 'Voucher deleted Successfully',
    PositiveNumber: 'Value must be greater than 0',
    MinChars: 'Name must be at least 3 characters',
    MaxChars: 'Name must not exceed 50 characters',
    DeleteVoucher: 'Delete Voucher?',
    DeleteVoucherText: 'This cannot be reversed.',
    DeleteConfirm: 'Delete',
    Save: 'Save',
    Edit: 'Edit',
    Delete: 'Delete',
  },

  PaymentSession: {
    Reason: 'Reason:',
  },

  IFTable: {
    TryAgain: 'Retry',
    TryAgainText: "Couldn't load data",
  },

  SideNavBar: {
    AdminProfile: 'My Profile',
  },
  AdminProfile: {
    logout: 'Logout',
    Email: 'Email',
    Role: 'Role',
    JoinedOn: 'Joined On',
    Countries: 'Registered Countries',
    Password: 'Password',
    ChangePassword: 'Change Password',
    ConfirmChangePassword: 'Confirm',
    CurrentPassword: 'Current Password',
    NewPassword: 'New Password',
    ConfirmNewPassword: 'Confirm New Password',
    Required: 'Required*',
    MinLength: 'Password must be at least 12 characters',
    PasswordsMustMatch: 'Passwords do not match',
    ChangePasswordSuccessMessage: 'Password changed Successfully',
    EditUserNameTitle: 'Edit User Name',
    EditUserNameLabel: 'User Name',
    EditUserNameConfirm: 'Confirm',
    ChangeUserNameSuccessMessage: 'User Name changed Successfully',
    AdminActions: 'Actions',
    AdminActionsFilterPlaceHolder: 'Filter actions by',
    SaveRole: 'Save',
    EditRole: 'Edit',
    DeleteRole: 'Delete',
    CancelEdit: 'Cancel',
    ModalTitle: 'Admin Profile',
    Blocked: 'Blocked',
    Unblock: 'Unblock',
    AdminUnblocked: 'Admin unblocked successfully',
    unblockModalTitle: 'Unblock Admin',
    unblockModalText:
      'Are you sure you want to unblock this admin? They will be able to log in again immediately.',
    unblockModalConfirm: 'Unblock',
  },
  AdminActions: {
    EditingAdmin: 'You',
    AdminPronoun: 'your',
    from: 'from',
    Changed: 'changed',
    Removed: 'removed',
    Created: 'created',
    Deleted: 'deleted',
    Activated: 'activated',
    Deactivated: 'deactivated',
    Invited: 'invited',
    Unblocked: 'unblocked',
  },
  Dashboard: {
    ListEnergyConsumption: 'Energy Consumption(kWh)',
    ListRedeemCount: 'Redeem Count',
    ActiveUsers: 'Active Users',
    TotalSales: 'Total Sales',
    TotalChargingTransactions: 'Total Charging Transactions',
    TotalAddedMoney: 'Total Added Money',
    TotalChargingMoney: 'Total Charging Money',
    TotalUsers: 'Total Users',
    Wallets: 'Wallets',
    TopUsers: 'Top Users',
    TopVouchers: 'Top Vouchers',
    NegativeWallets: 'Negative Wallets',
    PositiveWallets: 'Positive Wallets',
    InactiveUsers: 'Inactive Users',
    NewUsers: 'New Users',
    ReturningUsers: 'Returning Users',
    DashboardFilterPlaceholder: 'Filter Dashboard by',
    ThisYear: 'This Year',
    PreviousYear: 'Previous Year',
  },
  CountriesPage: {
    Add: 'Add',
    CountriesFilterPlaceholder: 'Filter countries by',
    CountryName: 'Name',
    CountryCode: 'Code',
    Currency: 'Currency',
    SW: 'SW:',
    NE: 'NE:',
    lat: 'lat',
    lon: 'lon',
    Cancel: 'Cancel',
    Save: 'Save',
    Edit: 'Edit',
    AddNewCountry: 'Add Country',
    Required: 'Required*',
    CountryNameForm: 'Country name',
    CountryCodeForm: 'Country code',
    CountryCurrencyForm: 'Currency name',
    Submit: 'Submit',
    AddCountrySuccessMessage: 'Country added Successfully',
    Symbol: 'Symbol',
  },
  Tariffs: {
    Time: 'Time',
    MaxPower: 'Max Power',
    Subscriptions: 'Subscriptions',
    CurrentType: 'Current Type',
    MoneyTariff: 'EGP/kWh',
    PointsTariff: 'PTS/kWh',
    EnergyConsumed: 'Energy Consumed (kWh)',
    NoTariffs: 'No tariffs found',
  },
  ChargingTokenPage: {
    Huid: 'Huid',
    ContractID: 'Contract ID',
    Reference: 'Reference',
    Type: 'Type',
    Design: 'Design',
    OwnerType: 'Owner Type',
    OwnerName: 'Owner Name',
    CreatedOn: 'Created On',
    Status: 'Status',
    Details: 'Details',
    ParentID: 'Parent ID',
    VoucherCode: 'Voucher',
    ChargingTokenFilterPlaceholder: 'Filter Tokens by...',
    SelectDesign: 'Select Design',
    NotSet: '--',
    ChargingTokenDeleted: 'Charging Token Deleted successfully',
    deleteModalTextToken:
      'Are you sure you want to delete this Charging Token?',
    deleteModalCancel: 'Cancel',
    deleteModalConfirm: 'Delete',
    deleteModalTitle: 'Confirm Delete',
    AddChargingTokenDesign: 'New Design',
    DesignName: 'Name',
    Required: 'Required*',
    Save: 'Save',
    Edit: 'Edit',
    Or: 'or',
    DragAndDrop: 'Drag and drop a file here or click',
    AddNewCard: 'Add New Card',
    Submit: 'Submit',
    ChargingTokenCreated: 'Charging Token Created Successfully',
    ChargingTokenBulkCreated: 'Charging Tokens Created Successfully',
    CreateChargingToken: 'New Token',
    DownloadSampleCSV: 'Download Sample CSV',
    ChargingTokenDesignAdded: 'Charging Token Design added successfully',
    ChargingTokenDesignDeleted: 'Charging Token Design deleted successfully',
    Invalid: 'Invalid',
    CreateDesign: 'New Design',
    NoDesignsFound: 'No Designs Found',
    EditDesign: 'Edit Design',
    deleteModalText: 'Are you sure you want to delete this Design?',
    MinThreeCharacters: 'This field must be at least 3 characters',
    HuidTitle: 'Huid:',
    ContractIdTitle: 'Contract ID:',
  },
  NotFound: {
    404: '404',
    NotFound: 'Not Found',
    RequestNotFound: " We're sorry, the page you requested could not be found",
    PleaseGoBack: 'Please go back to the home page',
    GoHome: 'GO HOME',
  },
  IFSelect: {
    Required: 'Required*',
  },
  Analytics: {
    TopCities: 'Top Active Cities',
    SitesCount: 'Sites count',
    City: 'City',
    EnergyConsumption: 'Consumption',
    Utilization: 'Utilization',
    NumberOfTransactions: 'Transactions count',
    PeakHour: 'Peak hour heatmap',
    Session: 'session',
    AverageDurationTitle: 'Avergae session duration',
    Dc: 'DC',
    Ac: 'AC',
    Minimum: 'min: ',
    Maximum: 'max: ',
    Transaction: ' transactions',
    Revenue: 'Transaction Revenue',
    SinceSentance: 'since last month',
    AverageRevenue: 'average / charge',
    AverageDuration: 'Average Duration',
    TopVouchers: 'Top Vouchers',
    RedeemedCount: 'Redeem Count',
    AveragePointsUsed: 'Average points used',
    Voucher: 'Name',
    TopSites: 'Top Sites',
    StationName: 'Name',
    RepeatedVisits: 'Repeated visits',
    ChargingSessions: 'Charging Sessions',
    Consumed: 'Consumed',
    AverageConsumption: 'Average Consumption',
    AverageDuration: 'Average Duration',
    KiloWattHour: 'kWh',
    KiloWatt: 'kW',
    Hours: 'hours',
    OverviewCurrent: 'Current',
    OverviewPrevious: 'Previous',
    Overview: 'Overview',
    SegmentedEnergy: 'Energy',
    SegmentedRevenue: 'Revenue',
    Transaction: ' transactions',
    Revenue: 'Transaction Revenue',
    AverageRevenue: 'average / charge',
    Co2: 'Co2 save',
    Kg: 'kg',
    Emitted: 'emiited',
    CarbonFootprint: 'Carbon footprint reduction',
    Co2Saved: 'Co2 saved',
    FuelSaved: 'Fuel saved',
    FootprintBody: 'charged this month',
    Connectors: 'Connectors used',
    Charged: 'kWh charged',
    Time: 'Time charged',
    TransactionsCard: 'Transactions',
    ChargingStations: 'Charging Stations',
    TotalConnectors: 'Connectors',
    AddedMoney: 'Total Money Added',
    SinceLast3Months: 'since previous 3 months',
    SinceLast6Months: 'since previous 6 months',
    SinceLastMonth: 'since previous month',
    SinceThisMonth: 'since previous month',
    SinceLastYear: 'since previous year',
    SinceThisYear: 'since previous year',
    UserSignup: 'User Signup',
    Person: 'person',
    TopUsers: 'Top Users',
    LastYear: 'Last year',
    LastMonth: 'Last month',
    Last3Months: 'Last 3 months',
    Last6Months: 'Last 6 months',
    LastWeek: 'Last week',
    ThisYear: 'This year',
    UsersActivity: 'Users Activity',
    UsersAdded: 'New users',
    TotalUsers: 'total users',
    UsersConsumption: 'Average consumption',
    UserConsumption: 'user avg consumption',
    UsersTransactions: 'Transactions count',
    AvgTransactionsCount: 'user avg transactions count',
    Cost: 'Average session cost',
    App: 'App',
    Card: 'Card',
    AvgRevenue: 'user avg revenue',
    Energy: 'Energy consumption (kWh)',
    NoData: 'No Data Available',
    EnergyChart: 'AC vs DC',
    TimeForFirstCharge: 'Time to first transaction',
    Count: 'Count',
    FailRate: 'Fail rate',
    PaymentBreakdown: 'Payment breakdown',
    AvergaeAddMoney: 'Average add money amount',
    WalletsBalance: 'avg balance of wallets',
    Charge: 'Charge',
    AddMoney: 'Add money',
    AvgBetweenSessions: 'Average time between sessions',
    UsersStatistics: 'Users Statistics',
    DashboardFilterPlaceholder: 'Filter Analytics by',
    Amount: 'Amount',
    Count: 'Count',
    success: 'success',
    failed: 'failed',
    pending: 'pending',
    AllTime: 'All time',
    ThisMonth: 'This Month',
    TransactionsStats: 'Transactions statistics',
  },
}

export default en
